<template>
  <div class="flex items-center justify-center py-10" v-if="!$store.state.order">
    <a-spin size="large" class="generation">
      <a-icon slot="indicator" type="loading" style="font-size: 60px; color: orange" spin />
    </a-spin>
  </div>

  <div v-else>
    <wizard-page-header :stepTitle="stepTitle" :readonly="readonly"></wizard-page-header>

    <div class="content-container" :class="[readonly && 'opacity-70 pointer-events-none']">
      <a-spin :spinning="submitting">
        <a-row class="px-4">
          <a-col :lg="6" :xs="0">
            <new-order-sidebar
              :hideTitle="true"
              :canEdit="false"
              :order_items="$store.state.order.order_items"
            >
              <template v-slot:chosenOffer>
                <div
                  class="flex flex-col items-center p-2 mb-3 bg-white border-2 rounded border-i4m-orange"
                >
                  <div class="mb-4 text-lg font-semibold text-i4m-orange">Offerta selezionata</div>

                  <div class="flex items-center w-full">
                    <svgicon
                      :name="`companies/${selectedOffer.company.url_logo}`"
                      width="150"
                      height="48"
                      :original="true"
                      class="mx-auto mb-6"
                    ></svgicon>
                  </div>

                  <company-coverages
                    :coverages="selectedOffer.company.coverages"
                    layout="col"
                  ></company-coverages>

                  <div class="mb-1 text-sm opacity-70">A partire da</div>
                  <div class="flex items-baseline mb-4">
                    <euro-value
                      :value="selectedOffer.value"
                      class="text-4xl font-bold"
                      smallerDecimals
                      symbolBefore
                      hideDecimalsIfZero
                    />
                    <div class="ml-1 text-sm opacity-75">/ anno</div>
                  </div>

                  <scalapay-widget
                    :amount="selectedOffer.value"
                    locale="it"
                    currencyPosition="after"
                    logoColor="#ed8936"
                    class="mb-4 text-center"
                  ></scalapay-widget>

                  <div class="mb-2 text-xs text-center opacity-70">
                    Il prezzo verrà confermato dopo aver completato la verifica della documentazione
                  </div>
                </div>
                <!-- content for the header slot -->
              </template>
            </new-order-sidebar>
          </a-col>
          <a-col :lg="18" :xs="24" class="pb-16">
            <h2 class="hidden mb-10 text-2xl md:block">{{ contentTitle }}</h2>

            <a-form :form="form" @submit="handleSubmit">
              <a-card class="mb-8" :style="{ maxWidth: '700px' }">
                <a-row :gutter="16">
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Nome</label>
                      <a-input
                        :disabled="true"
                        v-decorator="[
                          `name`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        class="mt-4"
                        formErrors
                      />
                    </a-form-item>
                  </a-col>

                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Cognome</label>
                      <a-input
                        :disabled="true"
                        v-decorator="[
                          `surname`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        class="mt-4"
                        formErrors
                      />
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16">
                  <a-col :xs="24" :lg="12">
                    <a-form-item>
                      <label class="font-bold" slot="label">Indirizzo email</label>

                      <a-input
                        html-type="email"
                        :disabled="true"
                        v-decorator="[
                          'email',
                          {
                            rules: [
                              { required: true, message: $t('msg.required') },
                              { type: 'email', message: $t('msg.requiredemail') }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Telefono</label>
                      <a-input
                        v-decorator="[
                          'phone',
                          {
                            rules: [
                              {
                                type: 'string',
                                required: true,
                                pattern: /^[+]*[(]{0,1}[0-9]{0,4}[)]{0,1}[-\s\./0-9]*$/,
                                message: $t('msg.requiredphone')
                              }
                            ]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>

                <!-- codice fiscale e derivati -->
                <a-row :gutter="16">
                  <a-col :xs="24" :lg="12">
                    <a-form-item
                      :colon="false"
                      has-feedback
                      :help="fiscalCodeCustomError"
                      :validate-status="''"
                    >
                      <label class="font-bold" slot="label">Codice fiscale</label>
                      <a-input
                        class="uppercase fiscal-code-input"
                        :allowClear="fiscalCodeValid"
                        :disabled="fiscalCodeValidating"
                        @change="validateFiscalCode"
                        v-decorator="[
                          'fiscalCode',
                          {
                            validateTrigger: 'blur',
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>

                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">{{ $t('fields.gender') }}</label>
                      <a-input
                        :disabled="true"
                        v-decorator="[
                          'gender',
                          {
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16">
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">{{ $t('fields.birthdate') }}</label>
                      <a-date-picker
                        :locale="locale"
                        :disabled="true"
                        format="DD/MM/YYYY"
                        :showTime="false"
                        v-decorator="[
                          'birthdate',
                          {
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-date-picker>
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">
                        {{ $t('fields.birthplace_complete') }}
                      </label>
                      <a-input
                        :disabled="true"
                        v-decorator="[
                          'birthplace_complete',
                          {
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-card>

              <!-- address data -->
              <a-card class="mb-8" :style="{ maxWidth: '700px' }">
                <a-row :gutter="16">
                  <a-col :xs="24" :lg="18">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">{{ $t('fields.address') }}</label>
                      <a-input
                        v-decorator="[
                          'address',
                          {
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xs="12" :md="6">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">{{ $t('fields.civic_number') }}</label>
                      <a-input
                        v-decorator="[
                          'civic_number',
                          {
                            rules: [
                              { required: true, message: $t('msg.required') },
                              {
                                type: 'string',
                                pattern: /^[a-zA-Z0-9\/]+$/,
                                message: $t('msg.onlynumberandletters')
                              }
                            ]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :xs="12" :md="6">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">{{ $t('fields.cap') }}</label>
                      <a-input
                        v-decorator="[
                          'cap',
                          {
                            validateTrigger: 'blur',
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                        placeholder=""
                        @change="validateCap"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">{{ $t('fields.city') }}</label>

                      <a-input
                        v-decorator="[
                          'city',
                          {
                            validateTrigger: 'blur',
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                        placeholder="Inserisci il nome della città..."
                      ></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="6">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">{{ $t('fields.province') }}</label>
                      <a-input
                        :disabled="true"
                        v-decorator="[
                          'province',
                          {
                            validateTrigger: 'blur',
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">{{ $t('fields.locality') }}</label>
                      <a-input
                        v-decorator="[
                          'locality',
                          {
                            validateTrigger: 'blur',
                            rules: [{ required: false, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-card>

              <!-- document type -->
              <!-- <a-card class="mb-8" :style="{ maxWidth: '700px' }">
                <a-row :gutter="16">
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Tipo di documento</label>
                      <a-select
                        v-decorator="[
                          'identity_document_type',
                          {
                            rules: [{ required: true, message: $t('msg.required') }],
                            initialValue: 'identity card'
                          }
                        ]"
                      >
                        <a-select-option
                          :value="type.value"
                          v-for="(type, index) in documentTypes"
                          :key="index"
                        >
                          {{ type.label }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Numero di documento</label>
                      <a-input
                        class="uppercase"
                        v-decorator="[
                          'identity_document_number',
                          {
                            rules: [
                              { required: true, message: $t('msg.required') },
                              {
                                type: 'string',
                                pattern: /^[a-zA-Z0-9]+$/,
                                message: $t('msg.onlynumberandletters')
                              }
                            ]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>

                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Scadenza documento</label>

                      <a-date-picker
                        :locale="locale"
                        format="DD/MM/YYYY"
                        :showTime="false"
                        v-decorator="[
                          'identity_document_expiry_date',
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        :disabledDate="disabledDatePast"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-card> -->

              <!-- is business -->
              <a-card class="mb-8" :style="{ maxWidth: '700px' }" title="Dati Attività">
                <a-row :gutter="16">
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Sei una società?</label>
                      <a-radio-group
                        v-decorator="[
                          `is_business`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        class="mt-4"
                        @change="toggleIsBusiness"
                        name="is_business"
                      >
                        <a-radio-button :value="false">No</a-radio-button>
                        <a-radio-button :value="true">Si'</a-radio-button>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16" v-if="is_business">
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Nome attività/società</label>
                      <a-input
                        v-decorator="[
                          `business_name`,
                          { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
                        ]"
                        formErrors
                      />
                    </a-form-item>
                  </a-col>

                  <a-col :xs="24" :lg="12">
                    <a-form-item>
                      <label class="font-bold" slot="label">Partita IVA</label>

                      <a-input
                        html-type="email"
                        v-decorator="[
                          'vat_number',
                          {
                            rules: [
                              { required: true, message: $t('msg.required') },
                              {
                                type: 'string',
                                pattern: /^[0-9]{11}$/,
                                message: $t('msg.pivavalid')
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :gutter="16" v-if="is_business">
                  <a-col :xs="24" :lg="12">
                    <a-form-item>
                      <label class="font-bold" slot="label">Indirizzo PEC</label>

                      <a-input
                        html-type="email"
                        v-decorator="[
                          'pec',
                          {
                            rules: [
                              { required: false, message: $t('msg.required') },
                              { type: 'email', message: $t('msg.requiredemail') }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>

                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Codice sistema di interscambio</label>
                      <a-input
                        v-decorator="[
                          'sdi',
                          {
                            rules: [
                              { required: false, message: $t('msg.required') },
                              {
                                type: 'string',
                                pattern: /^[a-zA-Z0-9]+$/,
                                message: $t('msg.onlynumberandletters')
                              }
                            ]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>

                <!-- address data -->
                <a-row :gutter="16" v-if="is_business">
                  <a-col :xs="24" :lg="16">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Indirizzo</label>
                      <a-input
                        v-decorator="[
                          'business_address',
                          {
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xs="12" :lg="6">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Numero civico</label>
                      <a-input
                        v-decorator="[
                          'business_civic_number',
                          {
                            rules: [
                              { required: true, message: $t('msg.required') },
                              {
                                type: 'string',
                                pattern: /^[a-zA-Z0-9\/]+$/,
                                message: $t('msg.onlynumberandletters')
                              }
                            ]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16" v-if="is_business">
                  <a-col :xs="12" :lg="6">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">CAP</label>
                      <a-input
                        v-decorator="[
                          'business_cap',
                          {
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                        placeholder=""
                        @change="e => validateCap(e, true)"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">{{ $t('fields.city') }}</label>

                      <a-input
                        v-decorator="[
                          'business_city',
                          {
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                        placeholder="Inserisci il nome della città..."
                      ></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xs="12" :lg="6">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Provincia</label>
                      <a-input
                        :disabled="true"
                        v-decorator="[
                          'business_province',
                          {
                            rules: [{ required: true, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16" v-if="is_business">
                  <a-col :xs="24" :lg="12">
                    <a-form-item :colon="false" class="mb-4">
                      <label class="font-bold" slot="label">Località</label>
                      <a-input
                        v-decorator="[
                          'business_locality',
                          {
                            rules: [{ required: false, message: $t('msg.required') }]
                          }
                        ]"
                      ></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-card>

              <a-card class="mb-8" :style="{ maxWidth: '700px' }">
                <h2 class="mb-3 text-lg">Informativa Privacy</h2>
                <a-row :gutter="16">
                  <a-col :xs="24" class="text-justify">
                    <a-form-item
                      :colon="false"
                      class="pt-0 pb-4 my-0 border-b border-solid border-i4m-orange"
                    >
                      <a-checkbox
                        v-decorator="[
                          'grant_privacy_insurance_policy',
                          {
                            validateTrigger: 'blur',
                            valuePropName: 'checked',
                            initialValue: false,
                            rules: [
                              {
                                required: true,
                                message: $t('msg.required'),
                                transform: value => value || undefined, // Those two lines
                                type: 'boolean' // Do the magic
                              }
                            ]
                          }
                        ]"
                      >
                        <span class="text-xs">
                          Dichiaro di aver preso visione dell'
                          <a
                            href="/privacy-policy/"
                            target="_blank"
                            class="font-bold text-i4m-orange"
                          >
                            informativa privacy
                          </a>
                          e di prestare il consenso per la comunicazione dei dati personali con le
                          modalità indicate al PUNTO 1 per le finalità di stipula di polizze
                          assicurative, la comunicazione dei dati personali agli altri soggetti
                          competenti indicati al PUNTO 4 per lo svolgimento degli obblighi normativi
                          previstie di aver preso visione ed accettare il contenuto dei
                          <a
                            href="/terms-and-conditions/"
                            target="_blank"
                            class="font-bold text-i4m-orange"
                          >
                            Termini e condizioni
                          </a>
                          <span class="font-bold text-i4m-orange">*</span>
                        </span>
                      </a-checkbox>
                    </a-form-item>
                    <a-form-item :colon="false" class="pb-2 mt-4 mb-0">
                      <a-checkbox
                        v-decorator="[
                          'grant_privacy_marketing',
                          {
                            validateTrigger: 'blur',
                            valuePropName: 'checked',
                            initialValue: false
                          }
                        ]"
                      >
                        <span class="text-xs">
                          Dichiaro di aver preso visione dell'
                          <a
                            href="/privacy-policy/"
                            target="_blank"
                            class="font-bold text-i4m-orange"
                          >
                            informativa privacy
                          </a>
                          e di prestare il consenso per la comunicazione dei dati personali con le
                          modalità indicate al PUNTO 1 per finalità di marketing
                        </span>
                      </a-checkbox>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-card>

              <h2 class="mt-10 mb-2 text-2xl">Modalità di invio preventivo</h2>
              <div v-if="receivingMethodError" class="pb-2 font-bold error-color">
                {{ receivingMethodError }}
              </div>
              <a-card class="mb-2" :style="{ maxWidth: '700px' }">
                <a-checkbox v-decorator="['by_mail']" v-model="by_mail" @change="toggleByMail">
                  Via posta cartacea
                </a-checkbox>

                <a-form-item v-if="by_mail" :colon="false" class="mt-3 mb-4">
                  <label class="font-bold" slot="label">Indirizzo di spedizione</label>
                  <a-input
                    v-decorator="[
                      'by_mail_address',
                      {
                        validateTrigger: 'blur',
                        rules: [{ required: false, message: $t('msg.required') }]
                      }
                    ]"
                  ></a-input>
                </a-form-item>
              </a-card>

              <a-card class="mb-2" :style="{ maxWidth: '700px' }">
                <a-checkbox v-decorator="['by_email']" v-model="by_email" @change="toggleByEmail">
                  Via email (ad un indirizzo diverso da quello segnalato)
                </a-checkbox>

                <a-form-item v-if="by_email" :colon="false" class="mt-3 mb-4">
                  <label class="font-bold" slot="label">
                    Indirizzo email dove ricevere la documentazione
                  </label>
                  <a-input
                    v-decorator="[
                      'by_email_address',
                      {
                        validateTrigger: 'blur',
                        rules: [
                          { required: false, message: $t('msg.required') },
                          { type: 'email', message: $t('msg.requiredemail') }
                        ]
                      }
                    ]"
                  ></a-input>
                </a-form-item>
              </a-card>

              <a-card class="mb-2" :style="{ maxWidth: '700px' }">
                <a-checkbox
                  v-decorator="['by_site']"
                  disabled
                  v-model="by_site"
                  class="disabled-no-opacity"
                >
                  Tramite email e accesso a questo portale (obbligatorio)
                </a-checkbox>
              </a-card>
            </a-form>
          </a-col>
        </a-row>
      </a-spin>
    </div>

    <div
      class="fixed bottom-0 left-0 right-0 z-10 flex items-center justify-between p-6 py-8 bg-white border-t border-gray-200"
    >
      <div class="flex flex-col" v-if="mobile">
        <div>Offerta selezionata</div>
        <div class="flex items-baseline">
          <span v-if="selectedOffer">
            <euro-value
              :value="selectedOffer.value"
              class="text-lg font-bold"
              smallerDecimals
              symbolBefore
              hideDecimalsIfZero
            />
          </span>

          <svgicon
            v-if="selectedOffer && !mobile"
            :name="`companies/${selectedOffer.company.url_logo}`"
            width="150"
            height="48"
            :original="true"
          ></svgicon>
        </div>
      </div>
      <div v-else></div>

      <a-button type="primary" class="big" @click="handleSubmit" :loading="submitting">
        {{ $t('cart.nextStep') }}
      </a-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import api from '@/api.js';
import questions from '@/questions';
// import utils from '@/utils';
import locale from 'ant-design-vue/es/date-picker/locale/it_IT';
import moment from 'moment';
import 'moment/locale/it';
const dayjs = require('dayjs');

export default {
  name: 'customer-full-info',

  data() {
    return {
      currentStep: 4,
      stepTitle: 'Completa i dati per ricevere il tuo preventivo',
      contentTitle: '5. Inserisci i dati mancanti e ricevi il tuo preventivo',

      form: this.$form.createForm(this, { name: 'customer-full-info' }),
      submitting: false,
      questions,
      // documentTypes: [
      //   { value: 'driving license', label: 'Patente di guida' },
      //   { value: 'identity card', label: 'Carta di identità' },
      //   { value: 'passport', label: 'Passaporto' }
      // ],
      // fiscal code related fields
      rawGender: null,
      fiscalCode: null,
      fiscalCodeValid: null,
      fiscalCodeCustomError: null,
      fiscalCodeValidating: false,
      // cap related fields
      capSelected: null,
      capIdSelected: null,
      // birthdate
      rawBirthDate: null,
      birthplace: null,
      // is business
      is_business: false,
      privacyPolicy: 'Testo privacy policy',
      termsPolicy: 'Testo termini di servizio',

      cities: null,
      by_mail: false,
      by_email: false,
      by_site: true,
      receivingMethodError: null,
      // selectedOffer: null

      locale
    };
  },

  computed: {
    readonly() {
      return !!(this.$store.state.order && this.$store.state.order.customer.address);
    },

    mobile() {
      return this.$mq.resize && this.$mq.below('768px');
    },
    // load selected offer
    selectedOffer() {
      return this.$store.state.order && this.$store.state.order.offers.find(offer => offer.chosen);
    }
  },

  mounted() {
    const customer = this.$store.state.order && this.$store.state.order.customer;
    if (customer) {
      this.form.setFieldsValue({
        name: customer.name,
        surname: customer.surname,
        phone: customer.phone,
        email: customer.email,
        fiscalCode: customer.fiscal_code,
        gender: customer.gender,
        birthdate: customer.birthdate,
        birthplace_complete: customer.birthplace_complete,
        address: customer.address,
        civic_number: customer.civic_number,
        cap: customer.cap,
        city: customer.city,
        province: customer.province,
        locality: customer.locality,
        is_business: customer.is_business,
        vat_number: customer.vat_number,
        business_name: customer.business_name,
        business_address: customer.business_address,
        business_civic_number: customer.business_civic_number,
        business_cap: customer.business_cap,
        business_city: customer.business_city,
        business_province: customer.business_province,
        business_locality: customer.business_locality,
        pec: customer.pec,
        sdi: customer.sdi,
        grant_privacy_insurance_policy: customer.grant_privacy_insurance_policy,
        grant_privacy_marketing: customer.grant_privacy_marketing
      });
    }

    // load selected offer
    // this.selectedOffer = this.$store.state.order.offers.find(offer => offer.chosen);
  },

  methods: {
    toggleIsBusiness(e) {
      this.is_business = e.target.value;
    },
    disabledDatePast(current) {
      // Can not select days before today and today
      return current && current < dayjs().startOf('day');
    },

    toggleByEmail(e) {
      if (!e.target.checked) return;

      const address = this.form.getFieldValue('email') || '';

      Vue.nextTick(() => {
        this.form.setFieldsValue({
          by_email_address: address
        });
      });
    },

    toggleByMail(e) {
      if (!e.target.checked) return;

      const address = this.form.getFieldValue('address') || '';
      const civic_number = this.form.getFieldValue('civic_number') || '';
      const city = this.form.getFieldValue('city') || '';
      const cap = this.form.getFieldValue('cap') || '';

      Vue.nextTick(() => {
        this.form.setFieldsValue({
          by_mail_address: address + ' ' + civic_number + ', ' + cap + ' ' + city
        });
      });
    },

    async validateCap(e, is_business = false) {
      this.cities = null;
      let cap = e.target.value;
      if (cap.length < 5) return;

      if (!cap) {
        this.capSelected = undefined;
        this.capIdSelected = undefined;
      } else {
        try {
          var resp = await api.validateCap(cap);
        } catch (error) {
          console.log('error validating cap', error);
          return;
        }

        this.cities = resp.data;

        this.form.setFields({
          // [is_business ? 'business_city' : 'city']: {
          //   value: resp.data[0] ? resp.data[0].place_name : null
          // },
          [is_business ? 'business_province' : 'province']: {
            value: resp.data[0] ? resp.data[0].admin_code2 : null
          }
        });
      }
    },

    async validateFiscalCode(e) {
      this.fiscalCodeValid = undefined;
      this.fiscalCodeCustomError = undefined;

      let code = e.target.value;

      if (code && code.length === 16) {
        code = code.toUpperCase();
        this.fiscalCodeValidating = true;

        try {
          var resp = await api.validateFiscalCode(code);
        } catch (error) {
          console.log('Error calculating fiscal code', error);
          this.fiscalCode = null;
          this.fiscalCodeValid = false;
          this.fiscalCodeCustomError = this.$t('msg.invalid');
          this.fiscalCodeValidating = false;
          return;
        }

        this.fiscalCodeValidating = false;

        // check over 18 years old
        let bday = moment(new Date(resp.data.birthDate));
        let _18yago = moment().subtract(18, 'years');

        if (bday.isAfter(_18yago)) {
          this.fiscalCodeValid = false;
          this.fiscalCodeCustomError = this.$t('register.18+');
          this.$notification.error({
            message: this.$t('register.18+'),
            duration: 5
          });
          return;
        }

        this.rawBirthDate = moment(resp.data.birthdate).local();
        this.rawGender = resp.data.gender;
        this.fiscalCode = code;
        this.form.setFields({
          gender: {
            value: resp.data.gender === 'M' ? this.$t('register.male') : this.$t('register.female')
          },
          birthdate: {
            value: this.rawBirthDate
          },
          birthplace_complete: {
            value: resp.data.birth_place_complete
          },
          fiscalCode: {
            value: this.fiscalCode
          }
        });
        this.birthplace = resp.data.birth_place;
        this.fiscalCodeValid = true;
      }

      // reset related fields
      if (!code || code === '') {
        this.form.setFields({
          gender: {
            value: undefined
          },
          birthdate: {
            value: undefined
          },
          birthplace_complete: {
            value: undefined
          },
          fiscalCode: {
            errors: []
          }
        });
      }
    },

    notificateError() {
      this.$notification.error({
        message: 'Ci sono errori nei dati forniti. Controlla e riprova',
        duration: 5
      });
    },

    handleSubmit() {
      this.receivingMethodError = null;
      this.submitting = true;

      this.form.validateFieldsAndScroll(
        { scroll: { offsetTop: 30, alignWithTop: true } },
        async (err, values) => {
          // must have at least 1 delivery method selected
          if (!this.by_site && !this.by_email && !this.by_email) {
            this.receivingMethodError = 'Almeno un metodo di consegna deve essere specificato';
            this.submitting = false;

            this.notificateError();

            return;
          }

          // is business need to have "at least" PEC or SDI
          if (this.is_business) {
            if (!values.sdi && !values.pec) {
              this.form.setFields({
                pec: { errors: [new Error('Almeno uno tra PEC e SDI deve essere presente')] }
              });
              this.submitting = false;

              this.notificateError();
              return;
            }
          }

          if (err) {
            console.log('Form is invalid: ', values, err);
            this.submitting = false;

            this.notificateError();

            return;
          }

          console.log('sending fields', values);

          try {
            // var resp = await api.saveCustomer({
            await api.saveCustomer({
              ...values,
              fiscal_code: this.fiscalCode,
              gender: this.rawGender,
              birthplace: this.birthplace,
              birthdate: values.birthdate.format('YYYY-MM-DD').toString(),
              // identity_document_expiry_date: values.identity_document_expiry_date
              //   .format('YYYY-MM-DD')
              //   .toString(),
              by_email: this.by_email,
              by_mail: this.by_mail,
              by_site: this.by_site
            });
            await this.$store.dispatch('getOrder', true);
          } catch (err) {
            if (err.response.status === 422) {
              let errors = err.response.data.errors;
              for (let field in errors) {
                this.form.setFields({
                  [field]: { errors: [new Error(errors[field][0])] }
                });
              }

              this.submitting = false;
            }

            return;
          }

          this.submitting = false;

          this.$router.push({ name: 'order' });
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/variables.scss';
/* deal with uppercasing when it appears the "clear" icon. (because the structure change) */
// .fiscal-code-input,
// .fiscal-code-input input {
//   text-transform: uppercase !important;
// }

.error-color {
  color: #f56565;
}

.disabled-no-opacity span {
  opacity: 1 !important;
  color: black;
}

input[disabled] {
  color: black !important;
}
.ant-statistic-content {
  color: $orange;
  font-weight: 800;
  font-size: 2.25rem;
}
.ant-statistic-content-value-decimal {
  font-size: 1.75rem;
}
</style>
